import i18n from "i18next";
import { LANG } from "./domain/i18n/i18n.constants";

i18n.init({
  lng: LANG.PORTUGUESE,
  fallbackLng: LANG.PORTUGUESE,
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
